import { Button, Flex, FloatButton, Typography, message } from 'antd'
import { CharacteristicsService, RestaurantService } from 'deliziora-client-module/client-web'
import React, { useEffect, useState } from 'react'
import { isMobile } from "react-device-detect";
import Characteristics from '../../Components/Characteristics/characteristics';

export default function NewFeatureManagementPage() {
    const [characteristics, setCharacteristics] = useState([])
    const [characteristicsSelected, setCharacteristicsSelected] = useState([])
    const restaurant = JSON.parse(localStorage.getItem("userData"));
    const [ButtonDisabled, setButtonDisabled] = useState(true)
    useEffect(() => {
        CharacteristicsService.returnAllCharacteristics()
            .then((res) => {
                setCharacteristics(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        RestaurantService.returnRestaurantById(restaurant._id.$oid).then((res) => {
            setCharacteristicsSelected(res.data.characteristics);
        })
    }, []);


    const cancelModifications = () => {
        CharacteristicsService.returnAllCharacteristics()
            .then((res) => {
                setCharacteristics(res.data);
                message.success("Modificações Anuladas!");
            })
            .catch((err) => {
                console.log(err);
                message.error("Não foi possível anular as modificações!");
            });

        RestaurantService.returnRestaurantById(restaurant._id.$oid).then((res) => {
            setCharacteristicsSelected(res.data.characteristics);
        })
    }

    const saveModifications = () => {
        RestaurantService.updateRestaurantById({
            id_restaurant: restaurant._id.$oid,
            name: restaurant.name,
            address: restaurant.address,
            latitude: restaurant.latitude,
            especialty: restaurant.especialty,
            complete_menu: restaurant.complete_menu,
            email: restaurant.email,
            longitude: restaurant.longitude,
            opening_hours: restaurant.opening_hours,
            contact: restaurant.contact,
            description: restaurant.description,
            img: restaurant.img,
            categories: restaurant.categories,
            characteristics: characteristicsSelected,
            updated_at: "",
        })
            .then((res) => {
                message.success("Dados actualizados com sucesso!");
                setInterval(() => {
                    RestaurantService.returnRestaurantById(restaurant._id.$oid)
                        .then((res) => {
                            localStorage.setItem("userData", JSON.stringify(res.data));
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                }, 1000);
            })
            .catch((err) => console.log(err));
    };


    const handleClickCharacteristics = (idChar) => {
        if (characteristicsSelected.includes(idChar)) {
            setCharacteristicsSelected((prevSelected) =>
                prevSelected.filter((id) => id !== idChar)
            );
        } else {
            setCharacteristicsSelected((prevSelected) => [...prevSelected, idChar]);
        }
    };

    return (
        <Flex align='center' justify='center' gap={20} vertical style={{
            width: isMobile ? "100vw" : "95vw",
            minWidth: isMobile ? "100vw" : "85vw",
            maxWidth: isMobile ? "100vw" : "85vw",
            height: isMobile ? "100vh" : "99vh",
            alignSelf: "center",
            justifySelf: "center"
        }}>
            <Typography.Title level={2} style={{
                marginTop: "1rem",
            }}>
                Gestão de Caracteristicas

            </Typography.Title>
            <Flex vertical style={{
                width: isMobile ? "100%" : "100%",
                minWidth: isMobile ? "100%" : "100%",
                maxWidth: isMobile ? "100%" : "100%",
                height: isMobile ? "100%" : "100%",
                alignSelf: "center",
                justifySelf: "center",
                overflowX: "auto",
                padding: "1rem",
            }}>
                <Characteristics
                    characteristics={characteristics}
                    handleClickCharacteristics={handleClickCharacteristics}
                    characteristicsSelected={characteristicsSelected}
                />
                <Flex gap={30} justify='center' align='center'>
                    <Button type='primary' style={{
                        backgroundColor: "black",
                    }} onClick={
                        cancelModifications
                    }
                    >
                        Anular Alterações
                    </Button>
                    <Button type='primary' style={{
                        backgroundColor: "black",
                    }} onClick={saveModifications}>
                        Salvar Alterações
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    )
}


